// src/DatabaseAdmin/RegionsGroupsView.jsx
import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { getAPIUrl } from '../api/apiUtils';
import styles from './RegionsGroupsView.module.scss';

const API_BASE_URL = getAPIUrl();

const RegionsGroupsView = () => {
  const [regions, setRegions] = useState([]);
  const [groups, setGroups] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);  
  const [expandedRegions, setExpandedRegions] = useState({});

  // Загрузка данных
  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      try {
        const [regionsResponse, groupsResponse] = await Promise.all([
          axios.get(`${API_BASE_URL}/crud/table/region?per_page=1000`),
          axios.get(`${API_BASE_URL}/crud/table/publics?per_page=1000`)
        ]);

        setRegions(regionsResponse.data.data || []);
        setGroups(groupsResponse.data.data || []);
        setError(null);
      } catch (error) {
        console.error('Ошибка загрузки данных:', error);
        setError('Ошибка загрузки данных: ' + (error.response?.data?.error || error.message));
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  // Группировка групп по регионам
  const getGroupsByRegion = (regionId) => {
    return groups.filter(group => group.region_id === regionId);
  };

  // Переключение развернутого состояния региона
  const toggleRegion = (regionId) => {
    setExpandedRegions(prev => ({
      ...prev,
      [regionId]: !prev[regionId]
    }));
  };

  // Статистика
  const stats = {
    totalRegions: regions.length,
    totalGroups: groups.length,
    regionsWithGroups: regions.filter(region => getGroupsByRegion(region.id).length > 0).length,
    averageGroupsPerRegion: regions.length > 0 ? (groups.length / regions.length).toFixed(1) : 0
  };

  if (loading) {
    return (
      <div className={styles.container}>
        <div className={styles.loading}>Загрузка данных...</div>
      </div>
    );
  }

  if (error) {
    return (
      <div className={styles.container}>
        <div className={styles.error}>{error}</div>
      </div>
    );
  }

  return (
    <div className={styles.container}>
      <div className={styles.header}>
        <h2>Регионы и Паблики</h2>
        <div className={styles.stats}>
          <div className={styles.statItem}>
            <span className={styles.statValue}>{stats.totalRegions}</span>
            <span className={styles.statLabel}>Регионов</span>
          </div>
          <div className={styles.statItem}>
            <span className={styles.statValue}>{stats.totalGroups}</span>
            <span className={styles.statLabel}>Пабликов</span>
          </div>
          <div className={styles.statItem}>
            <span className={styles.statValue}>{stats.regionsWithGroups}</span>
            <span className={styles.statLabel}>Регионов с пабликами</span>
          </div>
          <div className={styles.statItem}>
            <span className={styles.statValue}>{stats.averageGroupsPerRegion}</span>
            <span className={styles.statLabel}>Среднее пабликов на регион</span>
          </div>
        </div>
      </div>

      <div className={styles.regionsList}>
        {regions.map(region => {
          const regionGroups = getGroupsByRegion(region.id);
          const isExpanded = expandedRegions[region.id];
          
          return (
            <div key={region.id} className={styles.regionCard}>
              <div 
                className={styles.regionHeader}
                onClick={() => toggleRegion(region.id)}
              >
                <div className={styles.regionInfo}>
                  <h3 className={styles.regionName}>{region.city}</h3>
                  <span className={styles.regionTitle}>{region.region}</span>
                </div>
                <div className={styles.regionStats}>
                  <span className={styles.groupsCount}>
                    {regionGroups.length} пабликов
                  </span>
                  <span className={styles.expandIcon}>
                    {isExpanded ? '▼' : '▶'}
                  </span>
                </div>
              </div>
              
              {isExpanded && (
                <div className={styles.groupsList}>
                  {regionGroups.length > 0 ? (
                    regionGroups.map(group => (
                      <div key={group.id} className={styles.groupItem}>
                        <div className={styles.groupInfo}>
                          <span className={styles.groupTitle}>{group.title}</span>
                          {group.group_id && (
                            <span className={styles.groupId}>ID: {group.group_id}</span>
                          )}
                        </div>
                      </div>
                    ))
                  ) : (
                    <div className={styles.noGroups}>
                      В этом регионе пока нет пабликов
                    </div>
                  )}
                </div>
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default RegionsGroupsView;
